import {create} from 'zustand';
import {immer} from 'zustand/middleware/immer';
import {SelectOptionMap} from "../types";
import {SelectOption} from "@/types";

type MapStore = {
    project_detail_section: SelectOption[];
    shinsakikan_sinseitaio: SelectOption[];
    mitsumori_iraijino_kibonoki: SelectOption[];
    setOptionMap: (map: SelectOptionMap) => void;
}

export const useMapStore = create<MapStore>()(

    immer(
        (set, get) => ({
                project_detail_section:[],
                shinsakikan_sinseitaio:[],
                mitsumori_iraijino_kibonoki:[],

                setOptionMap: (map: SelectOptionMap) => {
                    set((state) => {
                        state.project_detail_section = map.project_detail_section;
                        state.shinsakikan_sinseitaio = map.shinsakikan_sinseitaio;
                        state.mitsumori_iraijino_kibonoki = map.mitsumori_iraijino_kibonoki;
                    })
                }
            }
        ))
)
